import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, Twitter, Linkedin } from "lucide-react";

const Footer = () => {
  return (
  <footer id="footer" style={{ background: '#0a0f1e', borderTop: '1px solid rgba(255,255,255,0.07)', color: '#f1f5f9', fontFamily: 'Poppins, sans-serif' }}>

    <style>{`
      .mm-footer-grid {
        display: grid;
        grid-template-columns: minmax(240px, 1.35fr) minmax(160px, 1fr) minmax(160px, 1fr) minmax(220px, 1.2fr);
        gap: 28px;
        margin-bottom: 48px;
        align-items: start;
      }
      @media (max-width: 980px) {
        .mm-footer-grid {
          grid-template-columns: 1fr 1fr;
          gap: 32px;
        }
      }
      @media (max-width: 640px) {
        .mm-footer-grid {
          grid-template-columns: 1fr 1fr;
          gap: 28px;
        }
        .mm-footer-brand,
        .mm-footer-contact {
          grid-column: 1 / -1;
        }
      }
    `}</style>

    {/* Main container */}
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '64px 32px 48px' }}>

      {/* Main Grid: Brand + Links + Contact in one row on desktop */}
      <div className="mm-footer-grid">

      {/* Brand Section */}
      <div className="mm-footer-brand">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
          <div style={{ width: 38, height: 38, background: '#fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden' }}>
            <img src="/LOGO.avif" alt="Musical Meet" style={{ width: '90%', height: 'auto' }} />
          </div>
          <span style={{ fontFamily: 'Gilroy-semiBold', fontSize: '1.2rem', color: '#f1f5f9', letterSpacing: 0.3 }}>musical meet</span>
        </div>
        <p style={{ color: '#64748b', fontSize: '0.875rem', lineHeight: 1.75, maxWidth: 240, margin: 0 }}>
          Connecting musical talent with event planners and individuals seeking exceptional live performances.
        </p>
        <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
          {[
            { href: 'https://www.instagram.com/musicalmeet_/', icon: <Instagram size={15} />, label: 'Instagram' },
            { href: 'https://x.com/musicalmeeet', icon: <Twitter size={15} />, label: 'Twitter' },
            { href: 'https://www.linkedin.com/company/musical-meet/', icon: <Linkedin size={15} />, label: 'LinkedIn' },
          ].map(({ href, icon, label }) => (
            <a key={label} href={href} aria-label={label} target="_blank" rel="noopener noreferrer"
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 36, height: 36, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#64748b', textDecoration: 'none', transition: 'all 0.2s', flexShrink: 0 }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(129,140,248,0.15)'; e.currentTarget.style.color = '#818cf8'; e.currentTarget.style.borderColor = 'rgba(129,140,248,0.35)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.color = '#64748b'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; }}>
              {icon}
            </a>
          ))}
        </div>
      </div>

          {/* Quick Links */}
          <div className="mm-footer-quick-links">
            <h4 style={{ fontFamily: 'Gilroy-semiBold', fontSize: '0.9rem', color: '#f1f5f9', marginBottom: 20, marginTop: 0, letterSpacing: 0.6, textTransform: 'uppercase' }}>Quick Links</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[
                { label: 'Browse Artists', href: '/all-artists' },
                { label: 'Browse Bands', href: '/all-bands' },
                { label: 'Browse Venues', href: '/all-venues' },
                { label: 'Join as a User', href: '/login?signup=1&artist=0' },
                { label: 'Host Venues', href: '/login?signup=1&venue=1' },
              ].map(({ label, href }) => (
                <li key={label}>
                  <a href={href} style={{ color: '#475569', fontSize: '0.875rem', textDecoration: 'none', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#a5b4fc'}
                    onMouseLeave={e => e.currentTarget.style.color = '#475569'}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

      {/* For Musicians */}
          <div className="mm-footer-for-musicians">
            <h4 style={{ fontFamily: 'Gilroy-semiBold', fontSize: '0.9rem', color: '#f1f5f9', marginBottom: 20, marginTop: 0, letterSpacing: 0.6, textTransform: 'uppercase' }}>For Musicians</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[
                { label: 'Join as an Artist', href: '/login?signup=1&artist=1' },
                { label: 'FAQ for Artists', href: '/how-it-works' },
                { label: 'Jamming Sessions', href: '/jamming' },
                { label: 'How It Works', href: '/how-it-works' },
              ].map(({ label, href }) => (
                <li key={label}>
                  <a href={href} style={{ color: '#475569', fontSize: '0.875rem', textDecoration: 'none', transition: 'color 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.color = '#a5b4fc'}
                    onMouseLeave={e => e.currentTarget.style.color = '#475569'}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

      {/* Contact */}
        <div className="mm-footer-contact">
          <h4 style={{ fontFamily: 'Gilroy-semiBold', fontSize: '0.9rem', color: '#f1f5f9', marginBottom: 20, marginTop: 0, letterSpacing: 0.6, textTransform: 'uppercase' }}>Contact Us</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <a href="tel:7779887407"
              style={{ display: 'flex', alignItems: 'center', gap: 12, color: '#475569', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#a5b4fc'}
              onMouseLeave={e => e.currentTarget.style.color = '#475569'}>
              <div style={{ width: 32, height: 32, borderRadius: 8, background: 'rgba(129,140,248,0.08)', border: '1px solid rgba(129,140,248,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Phone size={13} color="#818cf8" />
              </div>
              7779887407
            </a>
            <a href="mailto:contact@musicalmeet.com"
              style={{ display: 'flex', alignItems: 'center', gap: 12, color: '#475569', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#a5b4fc'}
              onMouseLeave={e => e.currentTarget.style.color = '#475569'}>
              <div style={{ width: 32, height: 32, borderRadius: 8, background: 'rgba(129,140,248,0.08)', border: '1px solid rgba(129,140,248,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Mail size={13} color="#818cf8" />
              </div>
              contact@musicalmeet.com
            </a>
          </div>
        </div>

      </div>
    </div>

    {/* Bottom bar */}
    <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', maxWidth: 1280, margin: '0 auto', padding: '18px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
      <p style={{ color: '#1e293b', fontSize: '0.82rem', margin: 0 }}>
        &copy; {new Date().getFullYear()} musical meet. All rights reserved.
      </p>
      <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
        {[
          { label: 'Privacy Policy', to: '/privacy' },
          { label: 'Terms of Service', to: '/terms' },
          { label: 'Refund Policy', to: '/refund' },
          { label: 'Cookie Policy', to: '/cookies' },
        ].map(({ label, to }) => (
          <Link key={label} to={to}
            style={{ color: '#334155', fontSize: '0.82rem', textDecoration: 'none', transition: 'color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.color = '#94a3b8'}
            onMouseLeave={e => e.currentTarget.style.color = '#334155'}>
            {label}
          </Link>
        ))}
      </div>
    </div>
  </footer>
  );
};

export default Footer;
